import type { ThemeWithoutTokens } from '../theme.types';

export const anchorTokens = (theme: ThemeWithoutTokens) =>
  ({
    anchorTextColor: theme.colors.primary.normal,
    anchorTextDecoration: 'none',
    anchorHoverTextDecoration: 'underline',
    anchorFocusTextDecoration: 'underline',
    anchorFocusTextColor: theme.colors.primary.dark,
  }) as const;
